import { retrieve } from "framework/http/endpoint";
import { createCollectionResponseFactory } from "framework/http/rest/jsonResponse";
import { fromApiTransportDate, fromApiTransportDateTimeOffset } from "framework/http/transport";
import { UrlPathOfApiLocation } from "common/paths";
import { getAgeTypeFromString, getCompetitionClassTypeFromString, getCompetitorTypeFromString, getDisciplineTypeFromString, getSeriesTypeFromString } from "public_app/view/entity";
var ApiUriPrefix = "".concat(UrlPathOfApiLocation, "/api/1/athletes");
function apiGetAthlete(idt) {
    var uri = "".concat(ApiUriPrefix, "/").concat(idt);
    return retrieve(uri, null, createCollectionResponseFactory(fromTransportAthlete));
}
function fromTransportAthlete(entity) {
    var result = JSON.parse(JSON.stringify(entity));
    result.validFor = fromApiTransportDate(entity.validFor);
    result.medicalCheckupExpiration = fromApiTransportDate(entity.medicalCheckupExpiration);
    result.age = getAgeTypeFromString("".concat(entity.age));
    result.rankingPoints.forEach(function (rp) {
        rp.medicalCheckupExpiration = fromApiTransportDate(rp.medicalCheckupExpiration);
        rp.age = getAgeTypeFromString("".concat(rp.age));
        rp.series = getSeriesTypeFromString("".concat(rp.series));
        rp.class = getCompetitionClassTypeFromString("".concat(rp.class));
        rp.personalClass = getCompetitionClassTypeFromString("".concat(rp.personalClass));
        rp.discipline = getDisciplineTypeFromString("".concat(rp.discipline));
        rp.rankingAge = getAgeTypeFromString("".concat(rp.rankingAge));
        rp.competitors = getCompetitorTypeFromString("".concat(rp.competitors));
    });
    return result;
}
function apiGetAthleteResults(idt) {
    var uri = "".concat(ApiUriPrefix, "/").concat(idt, "/competitions/results");
    return retrieve(uri, null, createCollectionResponseFactory(fromTransportAthleteResults));
}
function fromTransportAthleteResults(entity) {
    var result = JSON.parse(JSON.stringify(entity));
    result.date = fromApiTransportDate(entity.date);
    result.competitions.forEach(function (c) {
        c.completedAt = fromApiTransportDateTimeOffset(c.completedAt);
    });
    return result;
}
export { apiGetAthlete, apiGetAthleteResults, };
